import { Spinner } from "./Spinner";

/** Where a payment has got to while the student waits on us. */
export type PaymentStep = "opening" | "confirming" | null;

/**
 * "Confirming your payment…", over the screen they paid from.
 *
 * Paystack's sheet closes the moment the charge goes through, and the server
 * then asks Paystack whether it really did — a few seconds with nothing on
 * screen but the Pay button they just used. That read as "it didn't work",
 * which is how a student ends up tapping Pay again.
 */
export function PaymentBusy({ step }: { step: PaymentStep }) {
  if (step !== "confirming") return null;
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-label="Confirming your payment"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-bg/90 px-8 text-center backdrop-blur-sm"
    >
      <Spinner size={36} label="Confirming your payment" />
      <p className="m-0 font-[family-name:var(--font-display)] text-[18px] font-bold">
        Confirming your payment…
      </p>
      <p className="m-0 max-w-[280px] text-[13px] leading-[1.5] text-text-muted">
        This takes a few seconds. Please don't close the app or pay again.
      </p>
    </div>
  );
}
